import React from 'react';

import PropTypes from 'prop-types';
import {Form, FormikProps} from 'formik';
import {CallMade} from '@material-ui/icons';
import {Box, Grid} from '@material-ui/core';

import {FieldShape} from 'commons/shapes';
import {InferPropTypes} from 'commons/types/Types';
import {InformationLegalRepresentativeServiceRequest} from 'commons/models';
import {EfeButtonPrimary, EfeFormSection, EfeSupportMessage} from 'components';

InnerFormRepresentativeOfficialInfo.propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

function InnerFormRepresentativeOfficialInfo(
    props: InferPropTypes<
        typeof InnerFormRepresentativeOfficialInfo.propTypes &
            FormikProps<InformationLegalRepresentativeServiceRequest>
    >
) {
    const {values, errors, fields, isSubmitting, setFieldValue} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <Form noValidate>
            {fields && fields.length > 0 && (
                <Box m={2}>
                    <EfeSupportMessage />
                    <EfeFormSection
                        fields={fields}
                        values={values}
                        errors={errors}
                        setFieldValue={setFieldValue}
                    />
                    <Grid container direction='row' justifyContent='flex-end'>
                        <Box pt={6} width={160}>
                            <EfeButtonPrimary
                                fullWidth
                                disabled={isSubmitting}
                                type='submit'
                                endIcon={<CallMade />}>
                                {'OK'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            )}
        </Form>
    );
}

export default InnerFormRepresentativeOfficialInfo;
